// extracted by mini-css-extract-plugin
export var bodySections = "_e3-8";
export var gray = "_e3-7";
export var green = "_e3-4";
export var iconContainer = "_e3-9";
export var iconWidgetContainer = "_e3-1";
export var phoneIcon = "_e3-2";
export var red = "_e3-5";
export var statusDot = "_e3-3";
export var widgetContainer = "_e3-0";
export var yellow = "_e3-6";